// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"9bab49c4ada07b91a578","238":"ddda5bb4644eee929275"}[chunkId] + ".js";
};